import { createContext } from 'react';

const AppContext = createContext({
  health: false,
  initialized: false,
});

export default AppContext;
